export default __webpack_public_path__ + "static/media/education.4b02fa37.svg";